import { Component, type ErrorInfo, type ReactNode } from 'react'

interface ErrorBoundaryProps {
  children: ReactNode
  onError?: (error: Error) => void
}

interface ErrorBoundaryState {
  failed: boolean
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { failed: false }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Tride renderer failed.', error, info.componentStack)
    this.props.onError?.(error)
  }

  render() {
    if (this.state.failed) {
      return (
        <section className="compatibility-message" role="alert">
          <p className="eyebrow">RENDER LINK LOST</p>
          <h1>TRIDE COULD NOT START</h1>
          <p>Reload the page or enable WebGL hardware acceleration in your browser.</p>
          <button className="primary-button" type="button" onClick={() => window.location.reload()}>
            Reload game
          </button>
        </section>
      )
    }
    return this.props.children
  }
}
